import { setCookie } from '@utils/common';
import { EVENTTYPE_COOKIE_KEY, MAX_COOKIE_KEY, MIN_COOKIE_KEY } from '@utils/constants';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

const Reset = () => {
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();
    const handleConfirm = () => {
        setCookie(EVENTTYPE_COOKIE_KEY, '');
        setCookie(MIN_COOKIE_KEY, '');
        setCookie(MAX_COOKIE_KEY, '');

        searchParams.set('min', '');
        searchParams.set('max', '');
        searchParams.set('etype', '');
        setSearchParams(searchParams);
    };

    return (
        <div
            onClick={handleConfirm}
            className="h-[67px] text-lg18 text-black093 leading-[25.2px] mx-[20px] lg:h-[auto] lg:text-base lg:text-black068 lg:leading-[21px] lg:mb-[18px] lg:mt-[10px] lg:mx-0"
        >
            <span className="inline-block pt-[21px] align-middle lg:pt-0">{t('I001')}</span>
            <button className="w-[14px] h-[14px] bg-refreshlight mt-[21px] ml-[8px] align-middle lg:mt-0 lg:bg-contain lg:w-[13px] lg:h-[13px]"></button>
        </div>
    );
};
export default Reset;
